import styled from 'styled-components'
import { colors } from 'styles/colors'

import BaseButton from 'components/Button'

export const Container = styled.div`
    padding: 10px 0;

    background-color: ${({ $color }) => $color};
    color: ${colors.white} !important;

    font-size: 12px;
`

export const Title = styled.h1`
    font-size: 14px;
    font-weight: 700;
`

export const Text = styled.p`
    font-weight: 400;
    font-size: 14px;

    color: ${colors.white};
`

export const Important = styled.span`
    font-weight: 700;
    color: ${colors.lime};
`

export const Button = styled(BaseButton)`
    width: 100%;
`
